import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import * as NotificationsActions from "../../../../store/notifications/notifications.actions";
import { StandardDesignParameters, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';
import { Observable, Subscription } from 'rxjs';
import { selectEventsAllLoading } from 'src/app/store/event/event.selector';

@Component({
	selector: 'app-events',
	templateUrl: './events.component.html',
	providers: [],
})

export class EventsComponent implements OnInit, OnDestroy {
	exporting$: Observable<boolean | undefined>;
	exportingSub: Subscription | undefined;

	exporting: boolean;
	blockedDocument: boolean = false;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
	) {
		this.initSelectors();
	}

	ngOnInit() {
		this.subscribeAll();

		this.onResize();

		setTimeout(() => {
			this.store.dispatch(AnalyticsActions.eventCustomPageView({ params: { page_title: 'Events' } }));
		}, 1000);
	}

	initSelectors(): void {
		this.exporting$ = this.store.select(selectEventsAllLoading);
	}

	subscribeAll(): void {
		this.store.dispatch(NotificationsActions.setTopbarTitleId({
			stringId: 'EVENTS'
		}));
		this.exportingSub = this.exporting$.subscribe(loading => {
			this.exporting = loading;
			this.blockedDocument = loading;
		});
	}

	ngOnDestroy(): void {
		this.exportingSub?.unsubscribe();
	}

	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile() {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	layoutMarginResponsive() {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	gridTopMarginResponsive(): string {
		return (this.screenWidth >= StandardDesignParameters.MIN_WIDTH_MX7) ? "mt-4" : "mt-2";
	}
}
